import { ASSOCIATION_KEYS } from "./keys.js";
import { associationProfile } from "./profile.js";
export const associationModule = {
    code: "ASSOCIATION",
    profile: associationProfile,
    moduleKeys: ASSOCIATION_KEYS.map((key) => ({
        key,
        moduleClass: "sector-specific",
    })),
};
export { ASSOCIATION_KEYS } from "./keys.js";
//# sourceMappingURL=index.js.map